<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card v-if="transaction">
        <v-toolbar dark color="orange">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Transaction Detail</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list three-line subheader>
          <v-subheader class="orbit-subheading">{{ transaction.bank }}</v-subheader>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Description</v-list-item-title>
              <!-- <v-list-item-subtitle>{{ transaction.description }}</v-list-item-subtitle> -->
              <div class="worksheetDetail" v-html="`${adjustedWorksheetDetail}`"></div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
    };
  },
  computed: {
    adjustedWorksheetDetail() {
      const regex = /Approved By:[^\^]*\^/i; //BASICALLY WE WANT A REGEX THAT MATCHES UP TO A CARET IN A SERIES THAT CONTAINS NO OTHER CARETS
      return this.transaction.worksheetDetail
        .replace(regex, " Approved By: REDACTED^")
        .replaceAll("^", "<br>");
    },
  },
  props: {
    transaction: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.worksheetDetail {
  font-size: 12px !important;
  font-family: monospace;
}
</style>
